import { Link } from "react-router-dom";

export default function CtaSection() {
  return (
    <section className="relative mx-auto w-full max-w-7xl px-4 pb-4 md:px-6">
      <div className="relative overflow-hidden rounded-lg">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=stylized%20anime%20manga%20banner%20of%20diverse%20hero%20characters%20silhouetted%20against%20a%20vibrant%20warm%20orange%20sunset%20with%20floating%20ink%20splashes%2C%20abstract%20artistic%20backdrop%2C%20high%20detail%20editorial%20concept%20art&width=1600&height=500&seq=home-cta-2026&orientation=landscape"
            alt="漫画分类大全收藏背景"
            className="h-full w-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-700/90 to-black/60"></div>
        </div>
        <div className="relative z-10 flex flex-col items-start gap-6 px-6 py-14 md:flex-row md:items-center md:justify-between md:px-12">
          <div className="max-w-2xl">
            <h2 className="font-heading text-2xl text-white md:text-3xl">
              收藏这份漫画分类大全，随时发现想看的漫画
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-white/85">
              从漫画类型大全到漫画排行榜大全，漫途导航持续为你更新人气排行与推荐大全，让你不错过任何一部佳作。
            </p>
          </div>
          <div className="flex shrink-0 flex-wrap gap-3">
            <Link
              to="/category"
              className="whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-sm font-medium text-primary-700 transition-colors hover:bg-background-100"
            >
              立即开始探索
            </Link>
            <Link
              to="/about"
              className="whitespace-nowrap rounded-full border border-white/40 px-6 py-3 text-sm font-medium text-white transition-colors hover:bg-white/10"
            >
              了解我们
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}